import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { PrivateRoute } from "helper/route";
import AllInOneLayout from "components/allInOneDashboard/AllInOneLayout";

import Prime from "pages/product-info-pages/Prime";
import Portfolio from "pages/product-info-pages/Portfolio";
import OneStock from "pages/product-info-pages/OneStock";
import Protect from "pages/product-info-pages/Protect";
import Phc from "pages/product-info-pages/Phc";
import Sentiment from "pages/product-info-pages/Sentiment";
import Atlas from "pages/product-info-pages/Atlas";
import UsStrategy from "pages/product-info-pages/UsStrategy";

/**
 * Routes for /customer/product-info/*
 * Match props come from parent: match.path === "/customer/product-info"
 */
const ProductInfoRoutes = ({ match, isAuthenticated }) => (
  <AllInOneLayout>
    <Switch>
      <PrivateRoute
        exact
        auth={{ isAuthenticated }}
        path={`${match.path}/prime`}
        component={Prime}
      />
      <PrivateRoute
        exact
        auth={{ isAuthenticated }}
        path={`${match.path}/portfolio`}
        component={Portfolio}
      />
      <PrivateRoute
        exact
        auth={{ isAuthenticated }}
        path={`${match.path}/onestock`}
        component={OneStock}
      />
      <PrivateRoute
        exact
        auth={{ isAuthenticated }}
        path={`${match.path}/protect`}
        component={Protect}
      />
      <PrivateRoute
        exact
        auth={{ isAuthenticated }}
        path={`${match.path}/phc`}
        component={Phc}
      />
      <PrivateRoute
        exact
        auth={{ isAuthenticated }}
        path={`${match.path}/sentiment`}
        component={Sentiment}
      />
      <PrivateRoute
        exact
        auth={{ isAuthenticated }}
        path={`${match.path}/atlas`}
        component={Atlas}
      />
      <PrivateRoute
        exact
        auth={{ isAuthenticated }}
        path={`${match.path}/us-strategy`}
        component={UsStrategy}
      />
      <Redirect to="/customer/dashboard" />
    </Switch>
  </AllInOneLayout>
);

export default ProductInfoRoutes;
